"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.liveFlags = exports.flags = exports.flagDescriptions = exports.finalizedFlags = void 0;
const initialProductionFlags = {
    maintenanceMode: false,
    admin2fa: false,
    staff2fa: false,
    referralPartner2fa: false,
    all2fa: false,
    openRegistration: false,
    allowNegativeInventory: true,
    quickbooksSyncEnabled: true,
    // Flag: boolean;
}, initialStagingFlags = {
    maintenanceMode: false,
    admin2fa: false,
    staff2fa: false,
    referralPartner2fa: false,
    all2fa: false,
    openRegistration: true,
    allowNegativeInventory: true,
    quickbooksSyncEnabled: true,
    // Flag: boolean;
}, initialDevelopmentFlags = {
    maintenanceMode: false,
    admin2fa: false,
    staff2fa: false,
    referralPartner2fa: false,
    all2fa: false,
    openRegistration: true,
    allowNegativeInventory: true,
    quickbooksSyncEnabled: true,
    // Flag: boolean;
}, finalizedFlags = {
    flag: true,
}, nodeEnv = process.env.ENV;
exports.finalizedFlags = finalizedFlags;
let flags, liveFlags;
const flagDescriptions = {
    maintenanceMode: {
        name: 'Maintenance Mode',
        description: 'Prevent all non-administrative users from accessing the site',
        acl: ({ email }) => email === 'jeamigh@bedsforkids.org',
    },
    admin2fa: {
        name: 'Admin 2FA',
        description: 'Force two-factor authentication for Admins',
    },
    staff2fa: {
        name: 'Staff 2FA',
        description: 'Force two-factor authentication for Staff',
    },
    referralPartner2fa: {
        name: 'Referral Partner 2FA',
        description: 'Force two-factor authentication for Referral Partners',
    },
    all2fa: {
        name: 'All User 2FA',
        description: 'Force two-factor authentication for all users',
    },
    openRegistration: {
        name: 'Open Registration',
        description: 'Allow all users to register, rather than invited users and recurring donors only',
    },
    allowNegativeInventory: {
        name: 'Allow Negative Inventory',
        description: 'Allow inventory to go negative when packing trucks',
    },
    quickbooksSyncEnabled: {
        name: 'QuickBooks Sync',
        description: 'Sync inventory and financial events to QuickBooks. Disable to pause the integration entirely',
    },
};
exports.flagDescriptions = flagDescriptions;
switch (nodeEnv) {
    case 'production':
        exports.liveFlags = liveFlags = initialProductionFlags;
        exports.flags = flags = Object.assign(Object.assign({}, finalizedFlags), initialProductionFlags);
        break;
    case 'staging':
        exports.liveFlags = liveFlags = initialStagingFlags;
        exports.flags = flags = Object.assign(Object.assign({}, finalizedFlags), initialStagingFlags);
        break;
    case 'development':
        exports.liveFlags = liveFlags = initialDevelopmentFlags;
        exports.flags = flags = Object.assign(Object.assign({}, finalizedFlags), initialDevelopmentFlags);
        break;
    default:
        exports.liveFlags = liveFlags = initialProductionFlags;
        exports.flags = flags = Object.assign(Object.assign({}, finalizedFlags), initialProductionFlags);
}
